import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import Loading from "../../components/Loading";
import ChallanTable from "../../components/ChallanTable";
import { getChallanOrders } from "../../utils/api";
import useStore from "../../utils/store";

const AdminChallanDashboard = () => {
  const [dash, setDash] = useState([]);
  const [loading, setLoading] = useState(false);
  const startDate = useStore((state) => state.startDate);
  const endDate = useStore((state) => state.endDate);

  const getData = async () => {
    setLoading(true);
    const [success, data] = await getChallanOrders(startDate, endDate);
    if (success && Array.isArray(data)) {
      setDash(data);
    } else {
      setDash([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [startDate, endDate]);

  return (
    <Layout reload={getData}>
      {loading && <Loading />}
      <div className="flex flex-col gap-5 p-2">
        <div className="flex items-center justify-between bg-white p-4 rounded-2xl border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-slate-900 text-white flex items-center justify-center text-lg shadow-sm">
              📋
            </div>
            <div>
              <h1 className="text-lg font-black text-slate-800 tracking-tight">
                Challan Management
              </h1>
              <p className="text-xs font-semibold text-slate-400">
                {dash?.length || 0} Challan Group{dash?.length === 1 ? "" : "s"} Ready for Re-print
              </p>
            </div>
          </div>
          <button
            onClick={getData}
            className="inline-flex items-center gap-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-bold py-2 px-3.5 rounded-xl border border-slate-200 transition-all active:scale-95 cursor-pointer shadow-sm"
          >
            <span>🔄</span>
            <span>Refresh</span>
          </button>
        </div>
        <ChallanTable data={dash} />
      </div>
    </Layout>
  );
};

export default AdminChallanDashboard;
